"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STALE_RECONNECT_LINK = exports.STALE_FIGURE = exports.STALE_REASON = exports.STALE_CHIP = void 0;
exports.staleDataLine = staleDataLine;
exports.staleBarText = staleBarText;
/**
 * R5's strings (Paul, 2026-10-05), ONE copy for both clients (shared-copy-keys rule,
 * HANDOVER §2 rule 17). Agreed in writing between web and mobile in three rounds;
 * the table is `78-R5-STRINGS.md` in mobile's record and "R5 strings, FINAL" in
 * web's. Keys name the slot, not the text.
 *
 * The state: the remainder payload's `data_stale` (the card's window starts after
 * `data_through`, the newest transaction, and no bank has synced since). The card
 * then WITHHOLDS its figures instead of printing a confident $0, and says why once,
 * in the line under its title. `stale_reconnect_needed` picks the line: state A (a
 * bank needs reconnecting) or B (nothing to reconnect). Everything else says "not
 * up to date": one phrase for one state, and the date said once.
 */
const apiDates_1 = require("./apiDates");
/** The status chip, neutral tone (was "On Track" / "Over Budget"). */
exports.STALE_CHIP = "Not up to date";
/** Accessible value of a withheld figure ("—" is read as "dash"), and the bar reason. */
exports.STALE_REASON = "not up to date";
/** The visible text of a withheld figure. */
exports.STALE_FIGURE = "—";
/** State A's link text. Web links it to Connected Banks, mobile to Bank Management. */
exports.STALE_RECONNECT_LINK = "Reconnect your bank";
/**
 * The line under the card title, read right after the title and before any figure.
 * Returned in parts so a client can render the link: `lead` + `link` + `tail`.
 * State B has no link (`link` and `tail` are empty).
 */
function staleDataLine(dataThrough, reconnectNeeded, today = new Date()) {
    const lead = `No transactions since ${(0, apiDates_1.shortApiDateYearAware)(dataThrough, today)}.`;
    if (!reconnectNeeded)
        return { lead, link: "", tail: "", text: lead };
    const link = exports.STALE_RECONNECT_LINK;
    const tail = " to bring this up to date.";
    return { lead: `${lead} `, link, tail, text: `${lead} ${link}${tail}` };
}
/**
 * A bar's text while stale. It names only a figure it actually has: Bills and Debt
 * their amount due, Flexible spending its budget when one exists. Splash never: its
 * plan is a share of income RECEIVED this period, which is the stale quantity, so a
 * figure would be the false zero again. The accessible value equals this text.
 *
 * `formattedPlan` is the client's own currency string for the bar's plan, or null
 * when the bar has none.
 */
function staleBarText(bar, formattedPlan) {
    if (bar === "splash" || formattedPlan === null)
        return exports.STALE_REASON;
    const noun = bar === "flexible" ? "budgeted" : "due";
    return `${formattedPlan} ${noun} · ${exports.STALE_REASON}`;
}
//# sourceMappingURL=staleDataCopy.js.map